import React, { useState } from 'react';
import Topbar from '../../components/Topbar';
import Leftbar from '../../components/Leftsidebar';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';


const LenderList = () => {
  const [showSidebar, setShowSidebar] = useState(false);


  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  return (
    <>
      <body class="g-sidenav-show  bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                          <li className="breadcrumb-item mt-2"><span className='' style={{ color: "#f6f9fc" }}>Lenderlist</span></li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className='Table-title'>
                          <h5 className="mb-0">Lender Listing</h5>
                        </div>

                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone number</th>
                            <th>address</th>
                            <th>created</th>
                            
                          </tr>
                        </thead>
                        <tbody>

                          <tr>
                             <td>
                              <div style={{ width: "120px" }}>
                                <Link to={"/view-user/101"} target="_blank">
                                  <button className="viewproject-btn pull-right mb-1">
                                    <span style={{ color:"#292f36" }}>View User</span>
                                  </button>
                                </Link>
                              </div>
                            </td>
                            <td className="table-user">
                              <b>vikash </b>
                            </td>
                            <td className="table-user">
                              <b>vjha8300@gmail.com</b>
                            </td>
                            <td className="table-user">
                              <b>8699558774  </b>
                            </td>
                            <td className="table-user">
                              <b>India,Jaipur</b>
                            </td>

                            <td className="table-user">
                              <b style={{ textTransform: 'capitalize' }}>2025-01-26</b>
                            </td>

                           

                          </tr>

                        </tbody>
                      </table>
                    </div>


                  </div>
                  <Row>
                    {/* <Col xs={4}>
                    <div className='mb-1'>
                      <FormattedMessage id="Showing" /> {users?.length} <FormattedMessage id="accountants from page" /> {current_page} <FormattedMessage id="of" /> {pageCount}
                    </div>
                  </Col> */}
                    <Col xs={12}>
                      <div className='paginate-css'>
                        <ReactPaginate
                          previousLabel="<"
                          nextLabel=">"
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={1}
                          marginPagesDisplayed={0}
                          pageRangeDisplayed={1}
                          onPageChange={() => { }}
                          containerClassName="pagination"
                          activeClassName="active"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>


            </div>


          </main>
        </div>
      </body>
    </>
  )
}

export default LenderList;